import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_TLS_PROFILE = '/securityInfos';

export const SET_TLS_PROFILE_LOADING = 'SET_TLS_PROFILE_LOADING';
export const GO_TO_TLS_PROFILE_CREATE = 'GO_TO_TLS_PROFILE_CREATE';
export const GO_TO_TLS_PROFILE_EDIT = 'GO_TO_TLS_PROFILE_EDIT';
export const GO_TO_TLS_PROFILE_VIEW = 'GO_TO_TLS_PROFILE_VIEW';
export const GO_TO_TLS_PROFILE_COPY = 'GO_TO_TLS_PROFILE_COPY';
export const GO_TO_TLS_PROFILE_LIST = 'GO_TO_TLS_PROFILE_LIST';
export const GET_TLS_PROFILE_LIST = 'GET_TLS_PROFILE_LIST';
export const GET_TLS_PROFILE_LIST_PENDING = 'GET_TLS_PROFILE_LIST_PENDING';
export const GET_TLS_PROFILE_LIST_FULFILLED = 'GET_TLS_PROFILE_LIST_FULFILLED';
export const GET_TLS_PROFILE = 'GET_TLS_PROFILE';
export const GET_TLS_PROFILE_PENDING = 'GET_TLS_PROFILE_PENDING';
export const GET_TLS_PROFILE_FULFILLED = 'GET_TLS_PROFILE_FULFILLED';
export const CREATE_TLS_PROFILE = 'CREATE_TLS_PROFILE';
export const CREATE_TLS_PROFILE_PENDING = 'CREATE_TLS_PROFILE_PENDING';
export const CREATE_TLS_PROFILE_FULFILLED = 'CREATE_TLS_PROFILE_FULFILLED';
export const CREATE_TLS_PROFILE_REJECTED = 'CREATE_TLS_PROFILE_REJECTED';
export const UPDATE_TLS_PROFILE = 'UPDATE_TLS_PROFILE';
export const UPDATE_TLS_PROFILE_FULFILLED = 'UPDATE_TLS_PROFILE_FULFILLED';
export const UPDATE_TLS_PROFILE_REJECTED = 'UPDATE_TLS_PROFILE_REJECTED';
export const DELETE_TLS_PROFILE = 'DELETE_TLS_PROFILE';
export const DELETE_TLS_PROFILE_FULFILLED = 'DELETE_TLS_PROFILE_FULFILLED';
export const DELETE_TLS_PROFILE_REJECTED = 'DELETE_TLS_PROFILE_REJECTED';
export const SELECT_TLS_PROFILE = 'SELECT_TLS_PROFILE';

export enum TlsProfilePrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}
export enum TlsProfileMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export interface TlsProfile {
  id: string
  name: string,
  intfType?: string,
  tlsVersion?: string,
  tlsType?: string,
  authenType?: 'SIMPLE' | 'MUTUAL',
  privateKeyFile: string,
  passphrase: string,
  certificateFile: string,
  certificateAuthority: string,
  certificateDirectory: string,
  description?: string,
  depth?: string,
  hostname?: string,
  cipherFile?: string,
  sni: string,
  catype: 'SELFSIGNED' | 'XCCA',
  aftype?: string,
  litype?: 'INI1' | 'INI2' | 'INI3',
  serialnumber: string,
  keyalgorithm?: 'RSA_2048' | 'RSA_4096' |'RSA_8192' | 'ECDSA_256' | 'ECDSA_384' | 'ECDSA_521'
  commonName?: string,
  san?: string,
}

export interface TlsProfileState {
  entities: TlsProfile[]
  selected: TlsProfile[],
  single: TlsProfile | null
  createdId: string | null
  ui: TlsProfilesUIState
}

export interface TlsProfilesUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToTlsProfileListAction extends AnyAction {
  type: typeof GO_TO_TLS_PROFILE_LIST
}

export interface SetTlsProfileLoadingAction extends AnyAction {
  type: typeof SET_TLS_PROFILE_LOADING
  payload: { isLoading: boolean }
}

export interface GetTlsProfileListAction extends AnyAction {
  type: typeof GET_TLS_PROFILE_LIST
  payload: AxiosPromise<ServerResponse<TlsProfile>>
}

export interface GetTlsProfileListPendingAction extends AnyAction {
  type: typeof GET_TLS_PROFILE_LIST_PENDING
  payload: null
}

export interface GetTlsProfileListFulfilledAction extends AnyAction {
  type: typeof GET_TLS_PROFILE_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<TlsProfile>>
}

export interface GetTlsProfileAction extends AnyAction {
  type: typeof GET_TLS_PROFILE
  payload: AxiosPromise<ServerResponse<TlsProfile>>
}

export interface GetTlsProfilePendingAction extends AnyAction {
  type: typeof GET_TLS_PROFILE_PENDING
  payload: null
}

export interface GetTlsProfileFulfilledAction extends AnyAction {
  type: typeof GET_TLS_PROFILE_FULFILLED
  payload: AxiosResponse<ServerResponse<TlsProfile>>
}

export interface CreateTlsProfileThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateTlsProfileAction extends AnyAction {
  type: typeof CREATE_TLS_PROFILE
  payload: AxiosPromise<ServerResponse<TlsProfile>>
}

export interface CreateTlsProfilePendingAction extends AnyAction {
  type: typeof CREATE_TLS_PROFILE_PENDING
  payload: null
}

export interface CreateTlsProfileFulfilledAction extends AnyAction {
  type: typeof CREATE_TLS_PROFILE_FULFILLED
  payload: AxiosResponse<ServerResponse<TlsProfile>>
}

export interface CreateTlsProfileRejectedAction extends AnyAction {
  type: typeof CREATE_TLS_PROFILE_REJECTED
  payload: AxiosResponse<ServerResponse<TlsProfile>>
}

export interface UpdateTlsProfileThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateTlsProfileAction extends AnyAction {
  type: typeof UPDATE_TLS_PROFILE
  payload: AxiosPromise<ServerResponse<TlsProfile>>
}

export interface UpdateTlsProfileFulfilledAction extends AnyAction {
  type: typeof UPDATE_TLS_PROFILE_FULFILLED
  payload: AxiosResponse<ServerResponse<TlsProfile>>
}

export interface UpdateTlsProfileRejectedAction extends AnyAction {
  type: typeof UPDATE_TLS_PROFILE_REJECTED
  payload: AxiosResponse<ServerResponse<TlsProfile>>
}

export interface DeleteTlsProfileThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteTlsProfileAction extends AnyAction {
  type: typeof DELETE_TLS_PROFILE
  payload: AxiosPromise<ServerResponse<TlsProfile>>
}

export interface DeleteTlsProfileFulfilledAction extends AnyAction {
  type: typeof DELETE_TLS_PROFILE_FULFILLED
  payload: AxiosResponse<ServerResponse<TlsProfile>>
}

export interface DeleteTlsProfileRejectedAction extends AnyAction {
  type: typeof DELETE_TLS_PROFILE_REJECTED
  payload: AxiosResponse<ServerResponse<TlsProfile>>
}

export interface SelectTlsProfileAction extends AnyAction{
  type: typeof SELECT_TLS_PROFILE
  payload: TlsProfile[]
}

export type TlsProfileActionTypes =
  GoToTlsProfileListAction |
  SetTlsProfileLoadingAction |
  GetTlsProfileListAction |
  GetTlsProfileListPendingAction |
  GetTlsProfileListFulfilledAction |
  GetTlsProfileAction |
  GetTlsProfilePendingAction |
  GetTlsProfileFulfilledAction |
  CreateTlsProfileAction |
  CreateTlsProfilePendingAction |
  CreateTlsProfileFulfilledAction |
  CreateTlsProfileRejectedAction |
  UpdateTlsProfileAction |
  UpdateTlsProfileFulfilledAction |
  UpdateTlsProfileRejectedAction |
  DeleteTlsProfileAction |
  DeleteTlsProfileFulfilledAction |
  DeleteTlsProfileRejectedAction |
  SelectTlsProfileAction;
